export default __webpack_public_path__ + "static/imgCosmeticpng-e8d5565e9ab19e1f93c93446377f525b.png";